"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigilOfTheDamkenAbilityHandler = exports.SigilOfTheDamkenActorAbilityFactory = exports.SigilOfTheDamkenAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Passive_SigilOfTheDamken_1 = require("../../core/effects/core/Passive_SigilOfTheDamken");
const Duration_1 = require("../../core/Duration");
const EffectType_1 = require("../../core/effects/EffectType");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const DamageReciprocate_1 = require("../../core/effects/core/DamageReciprocate");
const Damage_1 = require("../../core/Damage");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class SigilOfTheDamkenAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SigilOfTheDamken;
        this.__typeName = "SigilOfTheDamken";
    }
}
exports.SigilOfTheDamkenAbilityArgs = SigilOfTheDamkenAbilityArgs;
let SigilOfTheDamkenActorAbilityFactory = class SigilOfTheDamkenActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SigilOfTheDamken", "OneEnemies", 4);
    }
};
SigilOfTheDamkenActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SigilOfTheDamken")
], SigilOfTheDamkenActorAbilityFactory);
exports.SigilOfTheDamkenActorAbilityFactory = SigilOfTheDamkenActorAbilityFactory;
let SigilOfTheDamkenAbilityHandler = class SigilOfTheDamkenAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            effect: new Passive_SigilOfTheDamken_1.Passive_SigilOfTheDamkenEffectArgs(),
            duration: Duration_1.Duration.Permanent,
        });
    }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        const effects = container.getEffectsOfType(ability.invokerId, EffectType_1.EffectType.Passive_SigilOfTheDamken);
        for (const effect of effects) {
            container.cancelEffect(sequence, effect);
        }
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Death", 100)
            ],
            onHit(sequence) {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(selectedEnemy, "feet"), "DarkLightning"));
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: ability.invokerId,
                    effect: new DamageReciprocate_1.DamageReciprocateEffectArgs(new Damage_1.Damage(__1.DamageType.Death, 10 * invokerLevel)),
                    duration: Duration_1.Duration.Turns(16),
                    sequence
                });
            }
        });
        container.registerEventHandler(ability.invokerId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CancelEventHandlersEventHandlerArgs([
            container.registerEventHandler(ability.invokerId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Combined(4, 1), new __1.ApplyEffectEventHandlerArgs(ability.invokerId, Target_1.Target.Self, Duration_1.Duration.Permanent, new Passive_SigilOfTheDamken_1.Passive_SigilOfTheDamkenEffectArgs())),
        ]));
    }
};
SigilOfTheDamkenAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SigilOfTheDamken)
], SigilOfTheDamkenAbilityHandler);
exports.SigilOfTheDamkenAbilityHandler = SigilOfTheDamkenAbilityHandler;
